import { MODULE_NAME } from './constants';

export const SET_FRIENDS_AND_FAMILY_STATE = `${MODULE_NAME}/SET_FRIENDS_AND_FAMILY_STATE`;

/**
 * Sets or toggles state of friendsAndFamilyMember
 * @param {boolean | 'toggle' }  newState
 */
export const setFriendsAndFamilyState = (newState) => ({
	type: SET_FRIENDS_AND_FAMILY_STATE,
	payload: { newState },
});
